import type { ReactNode } from 'react'
import { VariantNav } from './variants/VariantNav'
import type { NavLink } from '../lib/site-nav'
import { Footer } from './Footer'

/**
 * The site shell every page renders inside: adaptive glass nav, the page
 * `<main>`, and the footer, on the paper background. Pages own their own
 * section widths inside `<main>` (full-bleed heroes and dark bands break out,
 * content sits in a `container-*`). Long-form pages (blog, changelog, customer
 * stories) wrap their body in `container-prose` + `prose` for the reading
 * measure and article typography.
 */
export function SiteLayout({
  children,
  navDemoCta,
}: {
  children: ReactNode
  /** overrides the "Book a demo" header link, e.g. "View Docs" on dev pages */
  navDemoCta?: NavLink
}) {
  return (
    <div className="relative min-h-screen bg-paper text-ink-900">
      <div className="relative z-10">
        <VariantNav demoCta={navDemoCta} />
        <main>{children}</main>
        <Footer />
      </div>
    </div>
  )
}
